import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class MailchimpNotConnectedController extends Controller {
  @service declare store: Store;

  @tracked connecting = false;
  @tracked error?: any;

  @action
  templateDidInsert() {
    this.connecting = false;
  }

  @action
  async connectToMailchimp() {
    if (this.connecting) {
      return;
    }
    this.connecting = true;
    try {
      let signInModel = this.store.createRecord('devise-sign-in');
      await signInModel.save();
      window.location.href = '/auth/mailchimp';
    } catch (e) {
      this.error = e;
    }
  }
}
